import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/easy-lover")({
  component: EasyLoverLayout,
});

function EasyLoverLayout() {
  return <Outlet />;
}
